import {useEffect, useRef} from "react";

import {cancelActiveHelpTour} from "../lib/run-help-tour";

/**
 * Ends an active Driver.js tour when a sheet/dialog closes.
 * Pass the sheet `open` / `isVisible` flag.
 *
 * Handles both patterns:
 * - Sheet stays mounted with `open={false}` (transition effect)
 * - Sheet unmounts on close (cleanup effect — e.g. DAR `modalKey === SHEET && <DarSheet />`)
 */
export function useCancelHelpTourOnSheetClose(isOpen: boolean) {
  const wasOpenRef = useRef(isOpen);

  useEffect(() => {
    if (wasOpenRef.current && !isOpen) {
      cancelActiveHelpTour();
    }
    wasOpenRef.current = isOpen;
  }, [isOpen]);

  useEffect(() => {
    return () => {
      cancelActiveHelpTour();
    };
  }, []);
}
